import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVendorBills } from "../redux/slices/billSlice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const VendorBills = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bills, loading } = useSelector((state) => state.bill);
  const { user } = useSelector((state) => state.auth);
  const vendorId = user?.vendor?._id

  useEffect(() => {
    dispatch(getVendorBills({ vendorId }));
  }, [dispatch, vendorId]);

  /* ===============================
     EDIT BILL
  ================================ */
  const handleEdit = (billId) => {
    Swal.fire({
      title: "Edit Bill?",
      text: "Do you want to update bill details?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`/bill/edit/${billId}`);
      }
    });
  };

  /* ===============================
     PRINT BILL
  ================================ */
  const handlePrint = (billId) => {
    navigate(`/bill/preview/${billId}`);
  };

  return (

    <div className="container mt-4">
      <div className="card shadow-sm">

        {/* CARD HEADER */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <h6 className="mb-0">Vendor Bills</h6>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => navigate("/bill/create")}
          >
            + Create New Bill
          </button>
        </div>

        {/* CARD BODY */}
        <div className="card-body p-2">
          {loading ? (
            <p className="text-center text-muted small">Loading bills...</p>
          ) : bills?.length === 0 ? (
            <p className="text-center text-muted small">
              No bills found
            </p>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm table-sm table-bordered align-middle">
                <thead className="table-dark">
                  <tr className="text-small">
                    <th>#</th>
                    <th>Invoice No.</th>
                    <th>Date</th>
                    <th>Customer</th>
                    <th>Items</th>
                    <th>Total (₹)</th>
                    <th>Payment</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {bills.map((bill, index) => (
                    <tr key={bill._id} className="small">
                      <td>{index + 1}</td>
                      <td>{bill.invoiceNumber}</td>
                      <td>
                        {new Date(bill.createdAt).toLocaleDateString()}
                      </td>
                      <td>
                        {bill.customerName}
                        <br />
                        <span className="text-muted">
                          {bill.customerMobile}
                        </span>
                        <br />
                        <span className="text-muted">
                          {bill.customerAddress || "N/A"}
                        </span>
                      </td>
                      <td>{bill.items.length}</td>
                      <td className="fw-semibold">
                        ₹ {bill.grandTotal}
                      </td>
                      <td>{bill.paymentMode}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => handleEdit(bill._id)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-outline-success"
                          onClick={() => handlePrint(bill._id)}
                        >
                          Print
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorBills;
